
import Icon from 'JS/components/Icon.vue';
import ProductPrice from '../../ProductPrice.vue';
import QuantityField from 'JS/components/QuantityField.vue';
import { computed, defineComponent } from 'vue';
import { getAmountAvailable, getMaxQuantityExceeded } from 'Src/js/helpers/TireQuantityHelper';
import { IProductDetailProductJson } from 'JS/types/PDP';
import { IProductPriceViewModel } from 'JS/types/Product';
import { PropType } from 'vue';

export default defineComponent({
	name: 'InstallationQuoteProduct',
	components: {
		ProductPrice,
		QuantityField,
		Icon
	},
	props: {
		product: {
			type: Object as PropType<IProductDetailProductJson>,
			required: true,
		},
		price: {
			type: Object as PropType<IProductPriceViewModel>,
			required: true,
		},
		minBuyableQty: {
			type: Number,
			required: true,
		},
		quantity: {
			type: Number,
			required: true,
		},
	},
	setup(props, { emit }) {
		const qty = computed({
			get: () => props.quantity,
			set: qty => emit('update:quantity', qty),
		});
		const maxQuantityExceeded = computed(() => getMaxQuantityExceeded(props.product, qty.value));
		const amountAvailable = computed(() => getAmountAvailable(props.product));

		return {
			qty,
			maxQuantityExceeded,
			amountAvailable
		};
	}
});
